import { RootState } from "../../../../../models";
import { HardwareState } from "../../../../../models/state";

export type State = RootState;

export const getHardware = (state: State): HardwareState | undefined => state.retailer?.hardware;
export const getLookedUpProducts = (state: State) => getHardware(state)?.lookedUpProducts;
export const getSelectedEan = (state: State) => getHardware(state)?.selectedEan;
